import React, {useEffect} from 'react';
import {resetAllActiveNavItems} from "../../../utils/shared/navbar";

interface CorporateHatProps {
    isCorporateHatOpen: boolean;
    setIsCorporateHatOpen: (isCorporateHatOpen: boolean) => void;
    corpHatAccordionStates: boolean[];
    setCorpHatAccordionStates: (corpHatAccordionStates: boolean[]) => void;
    isHeaderBurgerOpen: boolean;
    setIsHeaderBurgerOpen: (isHeaderBurgerOpen: boolean) => void;
    isProfileOpen: boolean;
    setIsProfileOpen: (isProfileOpen: boolean) => void;
}
const CorporateHat = ({isCorporateHatOpen,setIsCorporateHatOpen, corpHatAccordionStates, setCorpHatAccordionStates,
                          isHeaderBurgerOpen, setIsHeaderBurgerOpen, isProfileOpen, setIsProfileOpen}: CorporateHatProps) => {

    const toggleDrawer = () => {
        setIsCorporateHatOpen(!isCorporateHatOpen);
        setIsHeaderBurgerOpen(false);
        setIsProfileOpen(false);
        resetAllActiveNavItems();
    };

    const toggleAccordion = (index: number) => {
        const updatedStates = corpHatAccordionStates.map((isOpen, i) => (i === index ? !isOpen : isOpen));
        setCorpHatAccordionStates(updatedStates);
    };

    useEffect(() => {
        if(isHeaderBurgerOpen || isProfileOpen){
            setIsCorporateHatOpen(false);
            setCorpHatAccordionStates([false, false]);
        }
    }, [isHeaderBurgerOpen, isProfileOpen]);

    return (
        <div className={`wk-corp-hat ${isCorporateHatOpen ? 'wk-corp-hat-drawer-opened' : ''}`}>
            <nav className="wk-corp-hat-nav" aria-labelledby="corporate-nav">
                <h5 className="sr-only" id="corporate-nav"> Wolters Kluwer Navigation </h5>
                <div className="wk-corp-hat-background">
                    <div className="wk-corp-hat-header">
                        <button className="wk-corp-button-toggle wk-corp-hat-button"
                            type="button"
                            aria-controls="wk-hat-drawer-2"
                            aria-expanded={isCorporateHatOpen}
                            onClick={toggleDrawer}
                        >
                            <span className="wk-button-text">Formazione IPSOA | Chi siamo</span>
                            <span className={`wk-button-icon wk-icon-chevron-down ${isCorporateHatOpen ? 'rotated' : ''}`} aria-hidden="true"></span>
                        </button>
                        <ul className="wk-corp-hat-quick-links wk-header-links">
                            <li className="wk-corp-hat-quick-link-list">
                                <a className="wk-corp-hat-quick-link" href="tel: 0282476100"> 02/82476100 </a>
                            </li>
                            <li className="wk-corp-hat-quick-link-list">
                                <a className="wk-corp-hat-quick-link" href="mailto:commerciale.formazione@wki.it" target="_blank"> commerciale.formazione@wki.it </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={`wk-corp-hat-drawer ${isCorporateHatOpen ? 'wk-corp-hat-drawer-opened' : ''}`}>
                    <button
                        className="wk-corp-hat-drawer-close wk-corp-hat-button"
                        aria-label="Close drawer."
                        type="button"
                        aria-controls="wk-hat-drawer-2"
                        onClick={toggleDrawer}
                    >
                        <span className="wk-icon-close" aria-hidden="true"></span>
                    </button>
                    <div className="wk-corp-hat-drawer-container" id="wk-hat-drawer-container-2">
                        <div className="wk-corp-hat-drawer-col">
                            <p className="wk-corp-hat-heading-about"> Formazione IPSOA </p>
                            <p className="wk-corp-hat-text"> Scuola di Formazione IPSOA è la Business School di Wolters Kluwer Italia. </p>
                        </div>
                        <div className="wk-divider"></div>
                        <div className="wk-corp-hat-drawer-col">
                            <h6 className={`wk-corp-hat-heading ${corpHatAccordionStates[0] ? 'wk-corp-hat-list-opened' : ''}`} onClick={() => toggleAccordion(0)}>
                                <span className="wk-corp-hat-heading-text">Chi siamo</span>
                                <span className={`wk-icon-chevron-down ${corpHatAccordionStates[0] ? 'rotated' : ''}`} aria-hidden="true"></span>
                            </h6>
                            <ul className={`wk-corp-hat-list ${corpHatAccordionStates[0] ? 'wk-corp-hat-list-opened' : ''}`}>
                                <li className="wk-corp-hat-list-item">
                                    <a className="wk-corp-hat-list-link" href="/scuola/home"> Chi siamo </a>
                                </li>
                                <li className="wk-corp-hat-list-item">
                                    <a className="wk-corp-hat-list-link" href="/formazione"> Catalogo </a>
                                </li>
                                <li className="wk-corp-hat-list-item">
                                    <a className="wk-corp-hat-list-link" href="/home/formazione-su-misura"> Progetti su misura </a>
                                </li>
                            </ul>
                        </div>
                        <div className="wk-corp-hat-drawer-col">
                            <h6 className={`wk-corp-hat-heading ${corpHatAccordionStates[1] ? 'wk-corp-hat-list-opened' : ''}`} onClick={() => toggleAccordion(1)}>
                                <span className="wk-corp-hat-heading-text">Per ottenere aiuto</span>
                                <span className={`wk-icon-chevron-down ${corpHatAccordionStates[1] ? 'rotated' : ''}`} aria-hidden="true"></span>
                            </h6>
                            <ul className={`wk-corp-hat-list ${corpHatAccordionStates[1] ? 'wk-corp-hat-list-opened' : ''}`}>
                                <li className="wk-corp-hat-list-item">
                                    <a className="wk-corp-hat-list-link" href="/page/contatti"> Contatti </a>
                                </li>
                                <li className="wk-corp-hat-list-item">
                                    <a className="wk-corp-hat-list-link" href={"/Faq.aspx"}> F.A.Q. </a>
                                </li>
                                <li className="wk-corp-hat-list-item">
                                    <a className="wk-corp-hat-list-link" href="/informazioni">Ti richiamiamo noi</a>
                                </li>
                            </ul>
                        </div>
                        <div className="wk-divider"></div>
                        <ul className="wk-corp-hat-quick-links wk-drawer-links">
                            <li className="wk-corp-hat-quick-link-list">
                                <a className="wk-corp-hat-quick-link" href="tel:+390123456789"> 02/824761 </a>
                            </li>
                            <li className="wk-corp-hat-quick-link-list">
                                <a className="wk-corp-hat-quick-link" href="mailto:commerciale.formazione@wki.it" target="_blank"> commerciale.formazione@wki.it </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default CorporateHat;
